<template>
	<div class="section full home">
		<slide-y-up-transition>
			<div v-show="showFirst" class="home-content">
				<div>
					Engage your<br>audience <span class="accent">worldwide</span><br>through authentic and<br>creative influencers.
				</div>
				<div>
					<router-link class="button" to="/influencers#julien">Discover our influencers</router-link>
				</div>
			</div>
		</slide-y-up-transition>
		<fade-transition>
			<div v-show="showSecond" class="bottom">
				<div class="container">
					<div class="social">
						<router-link to="/contact"><span class="instagram"></span></router-link>
						<!-- <router-link to="/contact"><span class="facebook"></span></router-link> -->
					</div>
					<div class="author">
						<i>Manon Tanti</i>
						<br>
						&copy; Anthony Passant
					</div>
				</div>
			</div>
		</fade-transition>
	</div>
</template>

<script>
export default {
	data () {
		return {
			showFirst: false,
			showSecond: false
		}
	},
	mounted () {
		setTimeout(() => {
			this.showFirst = true
		}, 200)
		setTimeout(() => {
			this.showSecond = true
		}, 600)
	}
}
</script>